// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"00df6cd2","70":"cadea0f0","71":"56f39a5d","195":"1242fb68","293":"d35bc1c1","349":"f40657c9","360":"70f0dbd6","419":"d49a1607","606":"3581faa4","621":"23154649","870":"e6d54ba4"}[chunkId] + ".chunk.js";
};